import { LensSDKException } from "lens-platform-sdk";
import { UserInvitation } from "lens-platform-sdk/dist/cjs/UserService";
import { useLensPlatformClient } from "./useLensPlatformClient";
import { useQuery } from "@tanstack/react-query";

export const useGetInvitations = () => {
  const lensPlatformClient = useLensPlatformClient();

  const {
    isLoading,
    isFetching,
    error,
    data: invitations,
    refetch,
  } = useQuery<UserInvitation[], LensSDKException>({
    queryKey: ["invitations"],
    queryFn: () => lensPlatformClient.user.getInvitations(),
    initialData: [],
  });

  return {
    loading: isLoading || isFetching,
    error,
    invitations,
    reload: refetch,
  };
};
